import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { convertedMulPrice, convertedDivPrice } from "../../../config/common";
import { Modal, ModalClose, Sheet, Typography } from "@mui/joy";
import Loading from "../../../Components/Loader";
import { approve } from "../../../config/provider";
import ConfirmPopup from "../../../Components/ConfirmPopup";
import {
  usdtTokenAddress,
  mldTokenAddress,
  metaspaceNFTMarketplaceAddress,
} from "../../../config/data";
import { bid, bidWithMatic } from "./contractData";
import ThreejsImage from "../ThreejsImagesPages/ThreejsImage";
import Swal from "sweetalert2";
import environmentVariables from "../../../config/environmentVariables";
const CollectionBoxImg = `${environmentVariables?.cdnUrl}girl.gif`
const ModelBack        = `${environmentVariables?.cdnUrl}marker1.png`
const HashImg          = `${environmentVariables?.cdnUrl}HashImg.png`

const Root = styled.div`
  width: 100%;
`;
const Container = styled.div`
  justify-content: center;
  align-items: center;
  text-items: center;
`;
const Imagewrapper = styled.div`
  background-size: cover;
  background-position: center;
  width: 100%;
  background-repeat: no-repeat;
  height: 500px;

  /* position: relative; */
  @media (max-width: 768px) {
    height: 750px;
  }
  @media (max-width: 1024px) {
    height: 750px;
  }
`;

const BannerTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: flex-start;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 10px;
`;
const BannerText = styled.text`
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 54px;
  text-transform: capitalize;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: "SweraDemo";
  @media (max-width: 880px) {
    font-size: 30px;
  }
`;
const NftValueViewContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: absolute;
  top: 90%;
  height: 130px;
  background: linear-gradient(360deg, #000000 41.25%, rgba(0, 0, 0, 0) 100%);
`;

const RightLeftContainer = styled.div`
  display: flex;
  justify-content: space-between;
  text-align: center;
  align-items: flex-start;
  padding: 0 30px;
  /* position: absolute; */
  width: 100%;
  top: 38%;
  padding: 0 5rem;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    padding: 0;
  }
  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    padding: 0;
  }
`;
const RightSideContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 50%;
  z-index: 99;
  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 20px;
  }
  @media (max-width: 1024px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;
const LeftsideWrapper = styled.div`
  /* padding: 0 0 0 30px; */
  margin: 0 40px;
  width: 50%;
  @media (max-width: 768px) {
    width: 100%;
    padding: 0;
    margin: 0;
  }
  @media (max-width: 1024px) {
    width: 100%;
    padding: 0;
    margin: 0;
  }
`;

const BidButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  width: 100%;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
  }
`;

const Button = styled.button`
  background: linear-gradient(45deg, #1a6d7e, #04a1c1);
  border-radius: 30px;
  outline: none;
  border: none;
  font-size: 18px;
  padding: 22px 0;
  cursor: pointer;
  color: #e9e9e9;
  width: 100%;
  transition: 1s;
  @media (max-width: 768px) {
    width: 100%;
  }
  @media (max-width: 1024px) {
    width: 100%;
  }
`;
const Buttonwrapper = styled.div`
  margin: 10px 10px;
  width: 50%;
  @media (max-width: 768px) {
    width: 100%;
  }
  @media (max-width: 1024px) {
    width: 100%;
  }
`;

const NftImmageWrapper = styled.div`
  background-image: url(${ModelBack});
  background-size: cover;
  background-color: none;
  background-position: center;
  border-radius: 20px;
`;
const NftImage = styled.img`
  background-color: #e5d8df;
  border-radius: 30px;
  /* padding: 10px 20px; */
  width: 100%;
  @media (max-width: 1260px) {
    width: 90%;
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`;
const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
const Icon = styled.div`
  padding: 0 10px;
`;
const BottomTextContainer = styled.div`
  /* position: absolute; */
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  bottom: 5px;
  border-radius: 0 0 30px 30px;
`;
const BottomTextWrapper = styled.div`
  /* width: 70%; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
`;
const Text = styled.text`
  font-size: 24px;
  padding: 20px 30px;

  @media (max-width: 768px) {
    font-size: 21px;
  }
  @media (max-width: 1024px) {
    font-size: 28px;
  }
`;

const MintingContainer = styled.div`
  background-color: #151a1c;
  border-radius: 10px;
  padding: 30px;
  /* display: flex; */
  /* margin: 25px 0; */
  @media (max-width: 880px) {
    margin: 10px 0;
  }
  @media (max-width: 625px) {
    width: 100%;
    padding: 20px;
  }
  @media (max-width: 425px) {
    width: 100%;
    margin: 0;
  }
`;

const ValueWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: center;
  padding: 30px 0;
  @media (max-width: 650px) {
    padding: 10px 0;
  }
`;
const ValueText = styled.text`
  color: #6a6a6a;
  font-size: 16px;
  font-weight: 600;
  text-transform: capitalize;
  margin: 5px 0;
  @media (max-width: 768px) {
    font-weight: 600;
    font-size: 16px;
  }
  @media (max-width: 1024px) {
    font-weight: 600;
    font-size: 18px;
  }
`;
const ValueText2 = styled.text`
  font-size: 40px;
  line-height: 38px;
  color: #f3f3f3;
  text-transform: capitalize;
  margin: 5px 0;
  font-weight: 600;
  @media (max-width: 768px) {
    font-weight: 600;
    font-size: 40px;
  }
  @media (max-width: 1024px) {
    font-weight: 600;
    font-size: 40px;
  }
`;
const Value = styled.text`
  color: #1e627c;
  position: absolute;
  top: 15px;
  right: 20px;
  font-weight: 600;
  font-size: 18px;
  margin: 5px 0;
  line-height: 19px;
  text-transform: capitalize;
  @media (max-width: 1024px) {
    font-size: 18px;
  }
  @media (max-width: 768px) {
    font-weight: 500;
    font-size: 15px;
  }
`;
const LineWrapper = styled.div``;
const Line = styled.div`
  opacity: 0.2;
  border: 1px solid #ffffff;
  height: 58px;
  width: 0;
  margin: 0 30px;
  @media (max-width: 1260px) {
    margin: 0 20px;
  }
  @media (max-width: 768px) {
    margin: 0 14px;
  }
`;

const Inputbidwrapper = styled.div`
  margin-right: 15px;
  position: relative;
  @media (max-width: 768px) {
    margin: 0;
    width: 100%;
  }
  @media (max-width: 1024px) {
    margin: 0;
    width: 100%;
  }
`;
const Input = styled.input`
  background: white;
  border-radius: 30px;
  padding: 20px 20px;
  outline: none;
  border: none;
  font-size: 18px;
  width: 100%;
`;

const BidCounterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  margin: 20px 0;
`;

const CountdownWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  margin: 0 0 10px 0;
  /* position: absolute; */
  /* right: 11%;
top: 15%; */
`;
const CountBoxWrapper = styled.div`
  background: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 13px 12px;
  margin: 0 5px;
  line-height: 10px;
`;

const CountdownText = styled.div`
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
`;
const CountText = styled.text`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
`;

const CountBox = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 12px;
  text-align: center;
  padding: 2px 0;
`;

const CountDownIconContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  margin: 10px 0;
`;

const ModalButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0 20px 0;
`;

const NameWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  text-align: center;
  justify-content: flex-start;
  flex-direction: column;
  padding: 0 0 30px 0px;
  border-bottom: 1px solid #2a2a2a;
  padding-bottom: 30px;
  width: 100%;
`;
const NameText = styled.text`
  font-size: 46px;
  font-weight: 600;
  text-transform: capitalize;
  @media (max-width: 768px) {
    text-align: left;
    font-size: 36px;
  }
  @media (max-width: 1024px) {
    text-align: left;
    font-size: 36px;
  }
`;
const NameTextMain = styled.text`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;
const SubCategory = styled.text`
  font-size: 20px;
  padding-bottom: 10px;
  color: #0a92ae;
`;

const NftCategoryHash = styled.div`
  display: flex;
`;
const LordImage = styled.img`
  width: 25px;
  margin-right: 10px;
`;
const NftCategory = styled.div`
  font-size: 14px;
  font-weight: 800;
  color: #490d81;
  text-transform: uppercase;
  background-color: #d3b1f3;
  padding: 10px 30px;
  border-radius: 50px;
  position: relative;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  ${(p) =>
    p.rare &&
    `
    background-color: #a5e3b8;
    color: #2b713e;
  `};
  ${(p) =>
    p.common &&
    `
    background-color: #dddddd;
    color: #535353;
  `};
`;
const NftHash = styled.div`
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 18px;
  font-weight: 800;
  background: -webkit-linear-gradient(0deg, #facf49, #fb7111);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #c95e73;
  text-transform: uppercase;
  background-color: #171e22;
  padding: 5px 20px;
  border-radius: 50px;
  position: relative;
  margin-bottom: 10px;
  margin-left: 10px;
  border: 1px solid #31393c;
  display: flex;
  align-items: center;
`;

const CollectionText = styled.div`
  display: flex;
  padding-top: 20px;
  align-items: center;
`;

const CollectionTextHead = styled.div`
  font-size: 16px;
  color: #6a6a6a;
  font-weight: 600;
`;

const CollectionTextName = styled.div`
  font-size: 22px;
  color: #dfdfdf;
`;

const CollectionTextFlex = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 10px;
`;

const CollectionImg = styled.img`
  width: 60px;
  height: 60px;
  background-color: #000;
  /* background-color: #137d92; */
  border-radius: 10px;
`;

const DetailBanner = ({
  data,
  name,
  image,
  allContractDetails,
  fetchData,
  specificData,
}) => {
  const [currency, setCurrency] = useState("MLD");
  const [inputValue, setInputValue] = useState("");
  const [showCreatedPopup, setShowCreatedPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const params = useParams();
  // console.log("params0000000", params);
  const [open, setOpen] = useState(false);
  const balance = {
    USDT: parseInt(allContractDetails?.usdtBal),
    MLD: parseInt(allContractDetails?.mldBal),
    MATIC: parseInt(allContractDetails?.maticBal),
  };
  const allowance = {
    USDT: parseInt(allContractDetails?.usdtMarketPlaceAllowance),
    MLD: parseInt(allContractDetails?.mldMarketPlaceAllowance),
  };
  const address = {
    USDT: usdtTokenAddress,
    MLD: mldTokenAddress,
    MATIC: "",
  };

  const contract = {
    USDT: allContractDetails?.usdtTokenContract,
    MLD: allContractDetails?.mldTokenContract,
    MATIC: allContractDetails?.provider,
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    // const numericValue = value.replace(/\D/g, "");
    // const truncatedValue = numericValue.slice(0, 2);
    setInputValue(value);
  };

  // const GetTokenDetails = ()=>{
  //   axios.get(`https://nftbe.metaspacechain.com/nftmarketplace/api/v1/get_token_details/${params.contract}/${params.tokenId}`)
  //   .then((response)=>{
  //     console.log("GetTokenDetails",response.data)
  //     setSpecificData(response.data)
  //   }).catch((error)=>{
  //     console.log(error)
  //   })
  // }

  // useEffect(()=>{
  //   GetTokenDetails();
  // },[])

  useEffect(() => {
    if (data?.tradeCurrency) {
      setCurrency(getTradeCurrency(data.tradeCurrency));
    }
  }, [data?.tradeCurrency]);

  const bidOffer = async () => {
    const inputPrice = convertedMulPrice(
      getTradeCurrency(data.tradeCurrency),
      inputValue
    );
    await bid(
      allContractDetails?.metaspaceNFTMarketplaceContract,
      params.contract,
      params.tokenId,
      inputPrice
    )
      .then(async (nftContractInfo) => {
        setLoading(false);
        setMessage("You bided successfully");
        setShowCreatedPopup(true);
        // console.log("data", nftContractInfo);
      })
      .catch((err) => {
        setLoading(false);
        setMessage(
          err?.error?.data?.message || err.message || "Something went wrong"
        );
        setShowCreatedPopup(true);
        console.log("err", err);
      });
  };

  const callMaticBid = async (price) => {
    const inputPrice = convertedMulPrice(
      getTradeCurrency(data.tradeCurrency),
      inputValue
    );
    await bidWithMatic(
      allContractDetails?.metaspaceNFTMarketplaceContract,
      params.contract,
      params.tokenId,
      inputPrice,
      data.price
    )
      .then(async (nftContractInfo) => {
        setLoading(false);
        setMessage("You bided successfully");
        setShowCreatedPopup(true);
        // console.log("data", nftContractInfo);
      })
      .catch((err) => {
        setLoading(false);
        setMessage(
          err.error.data.message || err.message || "Something went wrong"
        );
        setShowCreatedPopup(true);
        console.log("err", err);
      });
  };

  const checkIsUSDT = (address) => {
    if (
      address === "0xc2132D05D31c914a87C6611C10748AEb04B58e8F" ||
      address === "USDT"
    ) {
      return true;
    } else {
      return false;
    }
  };

  const convertedPrice = (currency, price) => {
    return checkIsUSDT(currency)
      ? Number(price) / 1000000
      : Number(price) / 1000000000000000000;
  };

  const callBid = async () => {
    setLoading(true);
    setOpen(false);
    // if (data.owner === allContractDetails?.address) {
    //   setLoading(false);
    //   alert("you have already bided.");
    // } else {
    let balanceOf = convertedPrice(
      getTradeCurrency(data?.tradeCurrency),
      balance[currency]
    );
    let allowancePrice = convertedPrice(
      getTradeCurrency(data?.tradeCurrency),
      allowance[currency] // market place
    );
    let price = convertedPrice(data?.tradeCurrency, parseInt(data?.price));
    // console.log(price, "pricepricepriceprice");

    if (balanceOf >= price) {
      // console.log(balanceOf, "pricepricepriceprice");
      if (currency === "MATIC") {
        await callMaticBid(price);
      } else {
        if (allowancePrice >= price) {
          await bidOffer();
        } else {
          if (allowancePrice < price) {
            await approve(contract[currency], metaspaceNFTMarketplaceAddress,allContractDetails?.provider);
          }

          // console.log("mld call before that");
          await bidOffer();
        }
      }
    } else {
      alert("not enough balance");
      setLoading(false);
    }
    // }
  };

  const getTradeCurrency = (id) => {
    let answer = "";

    if (id === "0xc2132D05D31c914a87C6611C10748AEb04B58e8F") {
      answer = "USDT";
    }
    if (id === "0xca082498a1dE55c5d13C5AF2B10CA5e1957349E6") {
      answer = "MLD";
    }
    if (id === "0x0000000000000000000000000000000000001010") {
      answer = "MATIC";
    }

    return answer;
  };

  // console.log("data11111111111", data && data);
  return (
    <>
      {loading && <Loading />}
      <Root>
        <Container>
          <Imagewrapper>
            <RightLeftContainer>
              <RightSideContainer>
                <NftImmageWrapper>
                  <ThreejsImage />
                </NftImmageWrapper>
              </RightSideContainer>
              <LeftsideWrapper>
                {/* <BannerTextWrapper>
                  <BannerText> NFT Name </BannerText>
                </BannerTextWrapper> */}
                <MintingContainer>
                  <NameWrapper>
                    {/* <SubCategory>SubCategory</SubCategory> */}
                    <NameTextMain>
                      <NftCategoryHash>
                        <NftCategory common>
                          {specificData?.category}
                        </NftCategory>
                        <NftHash>
                          <LordImage src={HashImg}></LordImage>{" "}
                          {specificData?.hash}
                        </NftHash>
                      </NftCategoryHash>
                      <NameText>{specificData?.name}</NameText>
                      {/* <NameText>Fangs of Fury</NameText> */}
                      <CollectionText>
                        <CollectionImg src={CollectionBoxImg}></CollectionImg>
                        <CollectionTextFlex>
                          <CollectionTextHead>Asset Type</CollectionTextHead>
                          <CollectionTextName>
                            {params.contract ===
                            "0x8fc3dec6148a9924870f205617c9c26b3010243e"
                              ? "Shootable"
                              : params.contract ===
                                  "0x6b229c5687d00590606f97045ad65d8dfbfe1bdc" ||
                                params.contract ===
                                  "0x8a41c16ed29205383cf920b7bc50846852945202"
                              ? "Melee"
                              : params.contract ===
                                "0x7eb272ac9b9fec60c5a7921ccc075152a961111c"
                              ? "Characters"
                              : params.contract ===
                                "0x69cc97aad84e5aebd72ec147d7b81b72e22c3ece"
                              ? "Vehicle"
                              : null}
                          </CollectionTextName>
                        </CollectionTextFlex>
                      </CollectionText>
                    </NameTextMain>
                  </NameWrapper>

                  <ValueWrapper>
                    <ValueText>Current Bid :</ValueText>
                    <ValueText2>
                      {specificData?.price} {specificData?.currency}
                    </ValueText2>
                  </ValueWrapper>
                  {/* <ValueWrapper>
                    <ValueText>
                      Min bidding Price :{" "}
                    </ValueText>
                    <ValueText2>
                      {data?.price && data?.tradeCurrency ? convertedDivPrice(data.tradeCurrency, data.price) : "-"}{" "}
                      {currency}
                    </ValueText2>
                  </ValueWrapper> */}
                  <BidButtonWrapper>
                    <Inputbidwrapper>
                      <Input
                        type="number"
                        value={inputValue}
                        // min={data?.price ? data.price.toString() : "0"}
                        onChange={handleInputChange}
                        placeholder="Enter your bid "
                      />
                      <Value> {specificData?.currency} </Value>
                    </Inputbidwrapper>
                    <Modal
                      aria-labelledby="modal-title"
                      aria-describedby="modal-desc"
                      open={open}
                      onClose={() => setOpen(false)}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Sheet
                        variant="outlined"
                        sx={{
                          maxWidth: 500,
                          borderRadius: "md",
                          p: 3,
                          bgcolor: "rgb(22 36 42 / 92%);",
                          boxShadow: "lg",
                        }}
                      >
                        <ModalClose
                          variant="outlined"
                          sx={{
                            top: "calc(-1/4 * var(--IconButton-size))",
                            right: "calc(-1/4 * var(--IconButton-size))",
                            boxShadow: "0 2px 12px 0 rgba(0 0 0 / 0.2)",
                            borderRadius: "50%",
                            bgcolor: "background.body",
                          }}
                        />

                        <Typography
                          id="modal-desc"
                          textColor="text.tertiary"
                          style={{ color: "white", fontSize: "18px" }}
                        >
                          You are about to place a bid for the{" "}
                          <span>{inputValue}</span> {currency} at a rate of{" "}
                          {data?.tradeCurrency && data?.highestBid
                            ? convertedDivPrice(
                                data?.tradeCurrency,
                                data?.highestBid
                              )
                            : "-"}
                          . We kindly request your confirmation before
                          proceeding.
                        </Typography>
                        <ModalButtonWrapper>
                          <Button onClick={() => callBid()}> Confirm</Button>
                        </ModalButtonWrapper>
                      </Sheet>
                    </Modal>
                    <Buttonwrapper
                      onClick={() => {
                        // console.log("inputValue", inputValue);
                        if (inputValue === "" || Number(inputValue) <= 0) {
                          // alert("input value should be greater than 0");
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Input value should be greater than 0",
                          });
                        } else {
                          setOpen(true);
                        }
                      }}
                    >
                      <Button> Make an offer</Button>
                    </Buttonwrapper>
                  </BidButtonWrapper>
                </MintingContainer>
              </LeftsideWrapper>
            </RightLeftContainer>
          </Imagewrapper>
        </Container>
        {showCreatedPopup && (
          <ConfirmPopup
            showPopup={showCreatedPopup}
            setShowPopup={setShowCreatedPopup}
            onClickFun={() => {
              setShowCreatedPopup(false);
              fetchData();
            }}
            text={message}
          ></ConfirmPopup>
        )}
      </Root>
    </>
  );
};

export default DetailBanner;
